<app-ion-common-header [id]="headerId" (backHeader)="backPage()" (focusHeader)="shownContent()" [title]="titlePage"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">

  <app-ion-common-label
    labelStyle="display-rg"
    labelDescription="Você tem algum vínculo com a Itaú Corretora?"
    label="Pessoas vinculadas têm algum tipo de relação com a Itaú Corretora."
    labelLink="Saiba mais"
    [ariaLabelLink]="ariaLabelLink"
    [idLink]="idLink"
    (sendClickLink)="openDetail()"
  ></app-ion-common-label>

  <div class="conent-center">
    <app-ion-common-radio [itens]="investimentBrokerType" [selectedValue]="selectedItem" (valueNameCode)="selectedItemCode=$event"
    (changeRadio)="changeItem(selectedItem=$event)" (valueNameRadio)="selectedName=$event"></app-ion-common-radio>
  </div>

  <app-ion-common-button class="hidden"
  [ngClass]="{'hidden': !buttonEnable || !selectedItem}" [attr.aria-hidden]="!buttonEnable || !selectedItem" 
  label="Continuar" (clickButton)="clickNext()"></app-ion-common-button>

</ion-content>